import React, { useContext } from 'react'
import { GLOBALS } from '../../utils/Globals'
import { Context } from '../../Context'
import { Layout } from '../../components/Layout'
import { DataListCourses } from '../../components/DataListCourses'
import { CoursesService } from '../../services/Courses'
import { Link } from 'react-router-dom'
import { Button } from 'primereact/button'
import { UserService } from '../../services/User'
export const CoursesList = () => {

  const { isAuth: token, userLogged } = useContext(Context);

  const getCoursesByUser = async () => {
    const coursesByUser = await UserService.getById(userLogged.id ,token);
    return coursesByUser.Course;
  }

  const isAdmin = () => {
    const rolLogged = userLogged.role;

    if (rolLogged === 'S') {
      return true
    }
  }

  const isCreator = () => {
    const rolLogged = userLogged.role;

    if (rolLogged === 'C') {
      return true
    }
  }

  const columns = [
    {
      field: 'name',
      header: 'Nombre',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por Nombre',
    },
    {
      field: 'version',
      header: 'Version',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por Version',
    },
    {
      field: 'status',
      header: 'Estado',
      sortable: true,
      filter: false,
    },
  ]

  const customActionButtons = ({ row }) => {
    return (
      <Link to={`${GLOBALS.menu.courses.viewcourse}/${row.id}`}>
        <Button
          type="button"
          icon="pi pi-chevron-circle-right"
          className="p-button-primary"
          tooltip="Ver"
        ></Button>
      </Link>
    )
  }

  return (
    <Layout>
      <DataListCourses
        menuItem={GLOBALS.menu.courses}
        listItems={() => isAdmin() || isCreator ? CoursesService.getAll(token) : getCoursesByUser()}
        bulkDelete={(ids) => CoursesService.bulkDelete(ids, token)}
        columns={columns}
        customActionButtons={customActionButtons}
      ></DataListCourses>
    </Layout>
  )
}